import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BottomNav from '../components/BottomNav';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <button onClick={() => navigate(-1)} className="btn-secondary" style={{marginBottom: '1rem'}}>
          ← Back
        </button>
        
        <h1 className="page-title">Product Details</h1>
        <div className="underline"></div>
        
        <div className="card">
          <div style={{textAlign: 'center', marginBottom: '2rem'}}>
            <img 
              src={`https://images.unsplash.com/photo-1600185365483-26d7a4cc7519?w=600&h=400&fit=crop`}
              alt="Product" 
              style={{maxWidth: '100%', borderRadius: '8px'}}
            />
          </div>
          
          <h2>Product #{id}</h2>
          <p className="page-subtitle">Premium Quality Item</p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Description</h3>
              <p>Detailed product description and specifications will be displayed here.</p>
            </div>
            <div className="feature-item">
              <h3>Price</h3>
              <p style={{fontSize: '1.5rem', color: 'var(--gold)'}}>Price on Request</p>
            </div>
          </div>
          
          <button className="btn-primary" style={{width: '100%', marginTop: '2rem'}}>
            Inquire Now
          </button>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default ProductDetail;
